<template>
  <div class="aside-actions" :style="{width: '100%'}">
    <outOfStock
      v-if="valid_actions.notify_me || isOutOfStock"
      :variants="product.product_variants"
      :notify_me_block="valid_actions.notify_me"
    />
    <requiresPersonalisation
      v-if="valid_actions.requires_personalisation"
      :product="product"
    />
    <personalisationInline
      v-if="valid_actions.requires_personalisation_inline"
      :product="product"
      :variantId="selectedVariant"
    />
    <addToCart
      v-if="valid_actions.add_to_cart"
      :product="product"
      :variantStock="variantStock"
      @variant-selected="updateSelectedVariant"
    >
      <optionalEngraving
        v-if="valid_actions.engrave"
        :product="product"
        :selectedVariant="selectedVariant"
        :selectedVariantInStock="selectedVariantAvailable"
      />
    </addToCart>
    <Messages
      :product="product"
    />
  </div>
</template>

<script>
import addToCart from "./add-to-cart.vue";
import outOfStock from "./out-of-stock.vue";
import requiresPersonalisation from "./requiresPersonalisation.vue";
import optionalEngraving from "./optional_engraving.vue"
import showActions from "./showActions.js";
import { mapGetters } from "vuex";
import Messages from "Templates/pages/productAside/Messages/index.vue";
import personalisationInline from "./personalisationInline.vue";

export default {
  components: {
    Messages,
    addToCart,
    outOfStock,
    requiresPersonalisation,
    optionalEngraving,
    personalisationInline
  },
  props: {
    product: { type: Object, default: () => ({ shopify_metafields: {}, product_variants: [] }) },
    variantStock: { type: Array, default: () => [] },
    isOutOfStock: { type: Boolean, default: false },
    upstreamConnectionFailure: { type: Boolean, default: false },
  },
  data(){
    const firstVariantId = Array.isArray(this.product.product_variants) && this.product.product_variants.length > 0 ? this.product.product_variants[0].id : null;
    return {
      selectedVariant: firstVariantId,
      selectedVariantAvailable: true,
      valid_actions:{
        notify_me: false,
        enquire_now: false,
        add_to_cart: false,
        engrave: false,
        requires_personalisation: false,
        requires_personalisation_inline: false,
        variants: false,
      }
    }
  },
  watch: {
    selectedVariant: {
      immediate: true,
      handler() {
        this.updateSelectedVariantAvailability();
      }
    },
    variantStock: {
      deep: true,
      handler() {
        this.updateSelectedVariantAvailability();
      }
    }
  },
  beforeMount() {
      const _showActions = showActions.getInstance();
      const sortingHat = _showActions.sort(this.isB2B ? 'b2b' : 'b2c' );
      sortingHat(this.product || {}, !!this.isOutOfStock || this.upstreamConnectionFailure, (response) => {
        this.valid_actions = { ...response };
      });
  },
  computed: {
    ...mapGetters(['isB2B']),
  },
  methods: {
    updateSelectedVariant(variantId) {
      this.selectedVariant = variantId;
      this.updateSelectedVariantAvailability();
    },
    updateSelectedVariantAvailability() {
      const variantId = this.selectedVariant;
      if (!variantId) {
        this.selectedVariantAvailable = false;
        return;
      }
      const stockRecord = (this.variantStock || []).find((item) => {
        const id = item?.id || item?.node?.id;
        return id === variantId;
      });
      if (stockRecord) {
        const available = typeof stockRecord.availableForSale === "boolean"
          ? stockRecord.availableForSale
          : !!stockRecord.node?.availableForSale;

        if(available && this.variantStock.length === 1){
          return;
        }

        const qty = typeof stockRecord.quantityAvailable === "number"
          ? stockRecord.quantityAvailable
          : stockRecord.node?.quantityAvailable;
        this.selectedVariantAvailable = available && (typeof qty === "number" ? qty > 0 : true);
        return;
      }
      const variantFallback = (this.product.product_variants || []).find((variant) => variant.id === variantId);
      if (variantFallback && typeof variantFallback.availableForSale === "boolean") {
        this.selectedVariantAvailable = variantFallback.availableForSale;
        return;
      }
      this.selectedVariantAvailable = true;
    }
  }
};
</script>
